import { cleanParagraphTags } from "@talladega/helpers";
import { CmsHeadingType } from "@talladega/types";
import classNames from "classnames";

export const CmsHeading = ({
  text,
  headingLevel,
  textSize,
  htmlId,
}: CmsHeadingType) => {
  const [size] = textSize ?? [];
  const Heading = (headingLevel?.[0] ?? "h3") as keyof JSX.IntrinsicElements;

  return text ? (
    <Heading
      className={classNames({
        "text-xs": size === "xs",
        "text-sm": size === "sm",
        "text-base": size === "base",
        "text-lg": size === "lg",
        "text-xl": size === "xl",
        "text-2xl": size === "2xl",
        "text-3xl": size === "3xl",
        "text-4xl": size === "4xl",
        "text-5xl": size === "5xl",
        "text-6xl": size === "6xl",
        "text-7xl": size === "7xl",
        "text-8xl": size === "8xl",
        "text-9xl": size === "9xl",
      })}
      id={htmlId ?? undefined}
      dangerouslySetInnerHTML={{
        __html: cleanParagraphTags(text),
      }}
    />
  ) : null;
};

export default {};
